export default __webpack_public_path__ + "static/media/DeviceColor.5fe0740c.svg";